(function () {
  function query(selector, context) {
    return (context || document).querySelector(selector);
  }

  function queryAll(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }

  function buildSectionRequestUrl(nextUrl, sectionId, origin) {
    var requestUrl = new URL(nextUrl, origin);
    requestUrl.searchParams.set('section_id', sectionId);
    return requestUrl.toString();
  }

  function getUniqueProductCards(incomingCards, existingProductIds) {
    var seenProductIds = existingProductIds || {};

    return incomingCards.filter(function (card) {
      var productId = card.getAttribute('data-product-id');
      if (!productId || seenProductIds[productId]) return false;

      seenProductIds[productId] = true;
      return true;
    });
  }

  function initProgressivePagination(root) {
    queryAll('[data-spclst-progressive-pagination]', root || document).forEach(function (paginationRoot) {
      if (paginationRoot.getAttribute('data-spclst-progressive-pagination-initialized') === 'true') return;

      var sectionRoot = paginationRoot.closest('.spclst-collection-grid-section');
      var productGrid = sectionRoot ? query('[data-spclst-product-grid]', sectionRoot) : null;
      var mode = paginationRoot.getAttribute('data-pagination-mode') || 'infinite_scroll';
      var isInfiniteScroll = mode === 'infinite_scroll';
      var sentinel = query('[data-spclst-progressive-pagination-sentinel]', paginationRoot);
      var status = query('[data-spclst-progressive-pagination-status]', paginationRoot);
      var loadMoreButton = query('[data-spclst-progressive-pagination-load-more]', paginationRoot);
      var retryButton = query('[data-spclst-progressive-pagination-retry]', paginationRoot);
      var sectionId = paginationRoot.getAttribute('data-section-id');
      var nextUrl = paginationRoot.getAttribute('data-next-url') || '';
      var inFlight = false;
      var observer = null;
      var activeController = null;
      var preloadDistance = Math.max(200, Math.min(500, Math.round(window.innerHeight * 0.25)));
      var connection = window.navigator && window.navigator.connection;

      if (
        !sectionRoot ||
        !productGrid ||
        (isInfiniteScroll && !sentinel) ||
        (!isInfiniteScroll && !loadMoreButton) ||
        !sectionId ||
        !nextUrl ||
        typeof window.fetch !== 'function' ||
        typeof window.DOMParser !== 'function' ||
        (isInfiniteScroll && typeof window.IntersectionObserver !== 'function') ||
        (connection && connection.saveData)
      ) {
        return;
      }

      paginationRoot.setAttribute('data-spclst-progressive-pagination-initialized', 'true');
      paginationRoot.classList.add('is-enhanced');

      function setState(state, message) {
        var isLoading = state === 'loading';
        var hasError = state === 'error';

        paginationRoot.classList.toggle('is-loading', isLoading);
        paginationRoot.classList.toggle('has-error', hasError);
        productGrid.setAttribute('aria-busy', isLoading ? 'true' : 'false');

        if (status) {
          status.textContent = message || '';
        }

        if (retryButton) {
          retryButton.hidden = !hasError || !isInfiniteScroll;
        }

        if (loadMoreButton) {
          loadMoreButton.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
          loadMoreButton.textContent = isLoading ? 'LOADING…' : hasError ? 'TRY AGAIN' : 'LOAD MORE';
        }
      }

      function stopLoading(message) {
        nextUrl = '';
        paginationRoot.setAttribute('data-next-url', '');
        if (observer) observer.disconnect();
        if (loadMoreButton) loadMoreButton.hidden = true;
        setState('complete', isInfiniteScroll ? '' : message || 'All products loaded.');
      }

      function sentinelIsNearViewport() {
        var rect = sentinel.getBoundingClientRect();
        return rect.top <= window.innerHeight + preloadDistance;
      }

      function loadNextPage() {
        if (inFlight || !nextUrl) return;

        var requestUrl = buildSectionRequestUrl(nextUrl, sectionId, window.location.origin);
        inFlight = true;
        activeController = window.AbortController ? new window.AbortController() : null;
        setState('loading', 'Loading more products…');

        window
          .fetch(requestUrl, {
            signal: activeController ? activeController.signal : undefined,
            credentials: 'same-origin',
            headers: {
              Accept: 'text/html',
              'X-Requested-With': 'XMLHttpRequest',
            },
          })
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Collection page request failed with status ' + response.status);
            }

            return response.text();
          })
          .then(function (html) {
            var doc = new window.DOMParser().parseFromString(html, 'text/html');
            var incomingGrid = query('[data-spclst-product-grid]', doc);
            var incomingPaginationRoot = query('[data-spclst-progressive-pagination]', doc);

            if (!incomingGrid) {
              throw new Error('Collection page response did not include a product grid');
            }

            var existingProductIds = {};
            queryAll('[data-spclst-collection-card]', productGrid).forEach(function (card) {
              var productId = card.getAttribute('data-product-id');
              if (productId) existingProductIds[productId] = true;
            });

            var incomingCards = queryAll('[data-spclst-collection-card]', incomingGrid);
            var uniqueCards = getUniqueProductCards(incomingCards, existingProductIds);
            var fragment = document.createDocumentFragment();

            uniqueCards.forEach(function (card) {
              fragment.appendChild(document.importNode(card, true));
            });

            productGrid.appendChild(fragment);

            nextUrl = incomingPaginationRoot
              ? incomingPaginationRoot.getAttribute('data-next-url') || ''
              : '';
            paginationRoot.setAttribute('data-next-url', nextUrl);

            if (incomingPaginationRoot) {
              var currentPage = incomingPaginationRoot.getAttribute('data-current-page');
              if (currentPage) paginationRoot.setAttribute('data-current-page', currentPage);
            }

            if (loadMoreButton && nextUrl) {
              loadMoreButton.setAttribute('href', nextUrl);
            }

            if (uniqueCards.length) {
              sectionRoot.dispatchEvent(
                new window.CustomEvent('spclst:collection-refresh', {
                  bubbles: true,
                  detail: { count: uniqueCards.length },
                })
              );
              setState('loaded', 'Loaded ' + uniqueCards.length + ' more products.');
            } else {
              setState('loaded', '');
            }

            if (!nextUrl) {
              stopLoading('All products loaded.');
              return;
            }

            if (isInfiniteScroll) {
              window.requestAnimationFrame(function () {
                if (sentinelIsNearViewport()) loadNextPage();
              });
            }
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            console.error('[SPCLST] Progressive collection loading failed:', error);
            setState('error', 'More products could not be loaded. Try again or use the page links below.');
          })
          .finally(function () {
            inFlight = false;
            activeController = null;
          });
      }

      if (retryButton) {
        retryButton.addEventListener('click', function () {
          setState('idle', '');
          loadNextPage();
        });
      }

      if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function (event) {
          event.preventDefault();
          loadNextPage();
        });
      }

      if (isInfiniteScroll) {
        observer = new window.IntersectionObserver(
          function (entries) {
            var shouldLoad = entries.some(function (entry) {
              return entry.isIntersecting;
            });

            if (shouldLoad) loadNextPage();
          },
          {
            rootMargin: preloadDistance + 'px 0px',
            threshold: 0,
          }
        );

        observer.observe(sentinel);
      }
    });
  }

  function boot() {
    initProgressivePagination(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initProgressivePagination(event.target);
  });
})();
